import { render, staticRenderFns } from "./NextTask.vue?vue&type=template&id=9b308be8"
import script from "./NextTask.vue?vue&type=script&lang=js"
export * from "./NextTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports